import type { OptionsDocument, PresentationOption, PresentationPage, QuoteDocument } from 'paintscout'
import { getFeature } from '../../../options'
import { getDefaultPresentation } from '../../../options/presentation/get-default-presentation'

export function getQuotePresentation(args: {
  options: OptionsDocument
  quote: QuoteDocument
  inactive?: boolean // return inactive presentations
  isWorkOrder?: boolean
  current?: boolean // return current presentations from options(sb feature)
}): PresentationOption {
  const { quote, options, isWorkOrder, inactive, current } = args
  const presentationsFeature = getFeature({ options, path: 'presentation.enabled' })
  const currentPresentation = options.options?.presentationOptions?.values?.[quote?.presentationTemplate?.key]

  const presentationsOnInvoices = getFeature({ options, path: 'presentation.presentationsOnInvoices' })

  if (isWorkOrder) {
    // down the road - we will probably beef-up the work-order
    // to have some presentation capabilities
    // ie: maps, etc
    return getDefaultPresentation({ options, isWorkOrder })
  } else if (quote?.is_invoice && (!presentationsOnInvoices || !presentationsFeature)) {
    return getDefaultPresentation({ options, invoice: quote.is_invoice })
  } else if (quote?.presentationTemplate && inactive) {
    return quote.presentationTemplate
  } else if (current && currentPresentation?.key) {
    return currentPresentation
  } else if (quote?.presentationTemplate?.active) {
    const partnerContent = getFeature({ options: options, path: 'partnerContent' })
    const sherwinWilliamsPages: PresentationPage[] = [
      {
        key: 'sherwin-williams-popular-colors',
        type: 'sherwin-williams',
        title: 'Sherwin Williams',
        label: 'Sherwin',
        sections: [
          {
            key: 'sherwin-williams-popular-colors',
            type: 'sherwin-williams-popular-colors',
            label: 'Popular Colors',
            title: 'Popular Colors'
          }
        ]
      },
      {
        key: 'sherwin-williams-color-samples',
        type: 'sherwin-williams',
        title: 'Sherwin Williams',
        label: 'Sherwin',
        sections: [
          {
            key: 'sherwin-williams-color-samples',
            type: 'sherwin-williams-color-samples',
            label: 'Color Samples',
            title: 'Color Samples'
          }
        ]
      },
      {
        key: 'sherwin-williams-color-help',
        type: 'sherwin-williams',
        title: 'Sherwin Williams',
        label: 'Sherwin',
        sections: [
          {
            key: 'sherwin-williams-color-help',
            type: 'sherwin-williams-color-help',
            label: 'Color Help',
            title: 'Color Help'
          }
        ]
      }
    ]
    const benjaminMoorePages = [
      {
        key: 'benjamin-moore-main',
        type: 'benjamin-moore',
        title: 'Benjamin Moore',
        label: 'Benjamin',
        sections: [
          {
            key: 'benjamin-moore-main',
            type: 'benjamin-moore-main',
            label: 'Benjamin Moore Main',
            title: 'Benjamin Moore Main'
          }
        ]
      }
    ]

    return {
      ...quote.presentationTemplate,
      pages: [
        ...(quote.presentationTemplate?.pages ?? []),
        ...(partnerContent?.sherwinWilliams?.presentationPages?.enabled ? sherwinWilliamsPages : []),
        ...(partnerContent?.benjaminMoore?.presentationPages?.enabled ? benjaminMoorePages : [])
      ]
    }
  } else {
    return getDefaultPresentation({ options })
  }
}
